module.exports = __webpack_public_path__ + "img/influencer.f7c4d9ce.jpg";